import { render, staticRenderFns } from "./AddResponsiblePerson.vue?vue&type=template&id=3fcd1015&scoped=true"
import script from "./AddResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./AddResponsiblePerson.vue?vue&type=script&lang=js"
import style0 from "./AddResponsiblePerson.vue?vue&type=style&index=0&id=3fcd1015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd1015",
  null
  
)

export default component.exports